export class SoakStyleRequest{
    soakstyleId : number;
    soakstyle: string;
    createdAt : Date;
    createdUser :string ;

    updatedAt : Date;
    updatedUser : string;
    versionFlag : number;
    isActive ?: boolean;

    constructor(soakstyleId : number,soakstyle: string,
        createdUser :string ,
        createdAt:Date,
        updatedAt : Date,
        updatedUser : string,
        versionFlag : number,isActive? : boolean)
    {
        this.soakstyleId = soakstyleId;
        this.soakstyle = soakstyle;
        this.isActive = isActive;
        this.createdAt = createdAt
        this.createdUser =createdUser ;

    }
}
